import React, { Component } from 'react'
import Car1 from '../images/chile.png'
import Car2 from '../images/whatsapp-2.png'
import Car3 from '../images/messenger.png'
import Car4 from '../images/facebook.png'
import Car5 from '../images/instagram-sketched.png'


import Grid from '@material-ui/core/Grid';


export default class footer extends Component {
  render() {
    return (
      <div style={{ backgroundColor: 'black', margintop: ''}}>



        <div style={{ height: '70px', backgroundColor: 'white', borderTop: '1.4px solid #eef3f4', marginTop: '' }}>


          <Grid style={{ width: '350px', margin: '0 auto', marginTop: '24px', height: '30px',textAlign:'center', justifyContent:'center' }}
            container item
          >
            <p style={{ color: 'black', fontSize: '15px', display: 'inline-block', marginTop: 5 }}>Atendemos todas las comunas de la RM</p>
            <div style={{
              height: '30px', width: '30px', backgroundImage: `url(${Car1})`, backgroundSize: '100%',
              borderRadius: '', display: 'inline-block', marginLeft: 10,
            }}>
            </div>
          </Grid>


        </div>

        <Grid container>
          <Grid item xs={5} sm={9} >
            <div style={{ margin: '0 auto', }}>
              <h1 style={{ fontSize: '17px', marginTop: '30px', marginLeft: '15px', color: 'white', marginBottom: 0 }}>Únete al club</h1>
              <p style={{ fontSize: '14px', marginLeft: '15px', color: 'white', marginTop: 0 }}>Suscríbete a nuestro boletín.</p>
            </div>
          </Grid>

          <Grid item xs={7} sm={3}

          >
            <div style={{ margin: '0 auto', width: 200 }}>

              <div style={{ height: '31px', width: '31px', backgroundImage: `url(${Car2})`, backgroundSize: '100%', marginTop: '30px', borderRadius: '', display: 'inline-block' }}  ></div>
              <div style={{ height: '31px', width: '31px', backgroundImage: `url(${Car3})`, backgroundSize: '100%', marginTop: '30px', marginLeft: '10px', borderRadius: '', display: 'inline-block' }}></div>
              <div style={{ height: '31px', width: '31px', backgroundImage: `url(${Car4})`, backgroundSize: '100%', marginTop: '30px', marginLeft: '10px', borderRadius: '', display: 'inline-block' }}></div>
              <div style={{ height: '31px', width: '31px', backgroundImage: `url(${Car5})`, backgroundSize: '100%', marginTop: '30px', marginLeft: '10px', borderRadius: '', display: 'inline-block' }}></div>

            </div>
          </Grid>


        </Grid>

      </div>
    )
  }
}
